export const applicationId = 'CarrierLogistics';
export const intentGeneral = 'general';
export const description = 'feedback.description';
export const confirmationMessage = 'feedback.confirmation_message';
